<template>
  <div>
    <GdprCompliance/>
  </div>
</template>

<script>
    import GdprCompliance from "./GdprCompliance";
    export default {
        name: "Main",
      components: {GdprCompliance},
      created() {
        this.$store.commit("SET_PAGE_TYPE", "gdprCompliance");
        this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%)");
        // console.log("Background Color", this.$store.state.pageFooterBackgroundColor);
      }
    }
</script>

<style scoped>

</style>
